export default __webpack_public_path__ + "static/media/pxec05-pxtv.d2166aa9.png";